module.exports = __webpack_public_path__ + "img/vambrace_agility.16030e28.png";